<template>
  <div class="form-prompt-gate">
    <DynamicFormModal
      ref="formModal"
      @submitted="onSubmitted"
      @dismissed="onDismissed"
    />
  </div>
</template>

<script>
import DynamicFormModal from "./DynamicFormModal.vue";
import FormService from "../../store/services/FormService";
import {
  isFormDismissedThisSession,
  resolveFormRouteContext,
} from "../../helper/formPromptSession";

export default {
  name: "FormPromptGate",
  components: { DynamicFormModal },
  data() {
    return {
      checking: false,
    };
  },
  watch: {
    "$route"(to) {
      this.checkPending(to);
    },
  },
  mounted() {
    this.checkPending(this.$route);
  },
  methods: {
    isModalOpen() {
      const modal = this.$refs.formModal;
      return !!(modal && modal.isOpen);
    },
    async checkPending(route) {
      if (this.isModalOpen()) return;
      if (!this.$store.state.auth || !this.$store.state.auth.user) return;
      const path = route && route.path ? route.path : "";
      if (path.indexOf("/login") === 0 || path.indexOf("/auth/") === 0) return;

      const routeContext = resolveFormRouteContext(route && route.name, path);
      this.checking = true;
      try {
        const res = await FormService.pending(routeContext);
        if (!res || res.status === false || !res.data || !res.data.form) {
          return;
        }
        const form = res.data.form;
        if (isFormDismissedThisSession(form.id)) {
          return;
        }
        if (this.isModalOpen()) return;
        this.$refs.formModal.open(form);
      } finally {
        this.checking = false;
      }
    },
    onSubmitted() {
      this.$nextTick(() => this.checkPending(this.$route));
    },
    onDismissed() {
      /* session-only dismiss — no refetch until next navigation/login */
    },
  },
};
</script>
